/**
 * @desc 通过渠道码获取单条信息
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.LogisticsQuotationResponseDto>;
export function request(
  params: API.tms.logisticsQuotation.info.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/tms/logisticsQuotation/info`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
